
const setUpCredentialsHandler = ({ TOKEN_KEY, REMEMBER_ME_KEY }) => {
	const getToken = () => localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
	const getRememberMe = () => localStorage.getItem(REMEMBER_ME_KEY) === "keep-logged-in";
	const setToken = (value, persist) => persist ? localStorage.setItem(TOKEN_KEY, value) : sessionStorage.setItem(TOKEN_KEY, value);
	const setRememberMe = (value) => value && localStorage.setItem(REMEMBER_ME_KEY, "keep-logged-in");
	const removeToken = () => { localStorage.removeItem(TOKEN_KEY); sessionStorage.removeItem(TOKEN_KEY)};
	const removeRememberMe = () => { localStorage.removeItem(REMEMBER_ME_KEY)};

	return {
		getToken,
		setToken,
		removeToken,
		setRememberMe,
		getRememberMe,
		removeRememberMe
	};
};

export default setUpCredentialsHandler;
